import * as React from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps
} from 'react-router-dom';

import store from './../store';
import { activeAccountCountrySel } from './../store/modules/signin';

interface IOpenRouteProps extends RouteProps {
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
}
type RenderComponent = (props: RouteComponentProps<any>) => React.ReactNode;

export class OpenRoute extends Route<IOpenRouteProps> {
  public render() {
    const state = store.getState();
    const { component: Component, ...rest }: IOpenRouteProps = this.props;
    const renderComponent: RenderComponent = props => {
      return (window.location.href.toString().includes('/ca/') &&
        activeAccountCountrySel(state) === 'US') ||
        (window.location.href.toString().includes('/us/') &&
          activeAccountCountrySel(state) === 'CA') ? (
        <Redirect to="/login" />
      ) : (
        <Component {...props} />
      );
    };

    return <Route {...rest} render={renderComponent} />;
  }
}

export default OpenRoute;
